export default "__VITE_ASSET__1dc8bbfb__"